<template>
  <div class="container">
    <h2 class="mb-5 text-center">{{page.title}}</h2>
    <div v-html="page.content"></div>

  </div>
</template>

<script>
    export default {
      data() {
        return {};
      },

      computed: {
        getPageId() {
          return this.$route.params.pageId;
        },
        page() {
          return this.$store.state.app.staticPage;
        }
      },

      watch: {
        getPageId(newValue) {
          this.$store.dispatch('app/getStaticPage', newValue);
        }
      },

      mounted() {
        this.$store.dispatch('app/getStaticPage', this.getPageId);
      }
    };
</script>
